import XayDungKeHoach from "./Components/xay-dung-ke-hoach/XayDungKeHoach";
import DangKiHocVien from "./Components/dang-ki-hoc-vien/DangKiHocVien";

export const danhSachTabKhoVatTu = (typeKho?: any, listCodeCN?: any) => [
    {
        eventKey: "0",
        title: "Kế hoạch đào tạo",
        component: <XayDungKeHoach
            className="h-bang-ds-phieu-ke-hoach"
        />,
    },
      {
        eventKey: "1",
        title: "Phiếu đăng ký học viên",
        component: <DangKiHocVien
            className="h-bang-ds-phieu-ke-hoach"
        />,
    },
];


export { };